import {
  Timestamp,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { ContentReportsRef, db } from "../../../../firebase";
import moment from "moment";
import { getSingleUser } from "../../../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";

export const getAllContentReports = async () => {
  try {
    const response = await getDocs(ContentReportsRef);

    return response;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getSingleReport = async (reportId) => {
  try {
    return await getDoc(doc(db, "reportTicket", reportId));
  } catch (error) {
    // console.log("error getting user:", error.message);
  }
};

export const getOrganizationReports = async (reportedItemId) => {
  try {
    const q = query(
      ContentReportsRef,
      where("reportedItemId", "==", reportedItemId)
    );
    // Fetch documents that match the query
    const querySnapshot = await getDocs(q);
    // Extract data from the query snapshot and return it
    const reports = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return reports;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    return []; // Return an empty array if there's an error
  }
};
export const getUserContentReports = async (userId) => {
  try {
    const queryRef = query(
      ContentReportsRef,
      where("reportedItemId", "==", userId)
    );
    const response = await getDocs(queryRef);
    return response;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getMostRecentUserContentReport = async (userId) => {
  try {
    const queryRef = query(
      ContentReportsRef,
      where("reportedItemId", "==", userId),
      orderBy("status.date", "desc"),  // Order by the date within the status object in descending order
      limit(1)  // Limit to only the most recent document
    );
    const response = await getDocs(queryRef);
    if (!response.empty) {
      return response.docs.map(doc => doc.data());  // Return the data of the most recent document
    }
    return [];  // Return empty array if no documents found
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    return [];
  }
};


export const contentReportsSearch = (array, keyword) => {
  const searchTerm = keyword.toLowerCase();
  return array.filter((value) => {
    return (
      (value.title &&
        value.title.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.createdAt &&
        moment
          .unix(value?.createdAt?.seconds)
          .format("MM-DD-YYYY")
          .toLowerCase()
          .match(new RegExp(searchTerm, "g"))) ||
      (value.id && value.id.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.type &&
        value.type.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.reason &&
        value.reason.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.reportedByData.userName &&
        value.reportedByData.userName
          .toLowerCase()
          .match(new RegExp(searchTerm, "g"))) ||
      (value.status.status &&
        value.status.status.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.status.action &&
        value.status.action.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.reportedItemId &&
        value.reportedItemId.toLowerCase().match(new RegExp(searchTerm, "g")))
    );
  });
};

export const updateContentReport = async (reportId, reportDoc) => {
  const reportDocRef = doc(db, "reportTicket", reportId);
  return await updateDoc(reportDocRef, reportDoc);
};

export const getFilterContentReports = async (
  reportReasonFilterOptions,
  reportTypeFilterOptions,
  reportStatusFilterOptions,
  creationDateRange,
  setLoading,
  handleFilterModalClose
) => {
  // Set loading to true at the beginning of the function
  setLoading(true);
  const deduplicate = (arr) => {
    const uniqueIds = new Set();
    const uniqueDocs = [];
    arr.forEach((doc) => {
      if (!uniqueIds.has(doc.id)) {
        uniqueIds.add(doc.id);
        uniqueDocs.push(doc);
      }
    });
    console.log("results:", uniqueDocs);
    handleFilterModalClose();
    return uniqueDocs;
  };

  try {
    let results = [];

    const reportTypeOptions = reportTypeFilterOptions.length > 0 ? reportTypeFilterOptions : [null];
    const reportReasonOptions = reportReasonFilterOptions.length > 0 ? reportReasonFilterOptions : [null];
    const reportStatusOptions = reportStatusFilterOptions.length > 0 ? reportStatusFilterOptions : [null];

    for (const reportType of reportTypeOptions) {
      for (const reportReason of reportReasonOptions) {
        for (const reportStatus of reportStatusOptions) {
          let queries = [];

          if (reportType !== null) {
            queries.push(where("type", "==", reportType));
          }

          if (reportReason !== null) {
            queries.push(where("reason", "==", reportReason));
          }

          if (reportStatus !== null) {
            queries.push(where("status.status", "==", reportStatus));
          }

          if (
            creationDateRange &&
            creationDateRange.startDate &&
            creationDateRange.endDate
          ) {
            queries.push(where("createdAt", ">=", creationDateRange.startDate));
            queries.push(where("createdAt", "<=", creationDateRange.endDate));
          }

          if (queries.length > 0) {
            const q = query(ContentReportsRef, ...queries);
            const querySnapshot = await getDocs(q);

            console.log("resultes query:::", querySnapshot.docs[0]);

            const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
              const userTemp = await getSingleUser(doc.data().reportedBy);
              return {
                id: doc.id,
                ...doc.data(),
                reportedByData: userTemp?.data() ? userTemp.data() : {},
              };
            });

            const queryResults = await Promise.all(fetchDetailsPromises);
            results = results.concat(queryResults);
          }
        }
      }
    }

    // Deduplicate the results before returning
    const uniqueResults = deduplicate(results);
    return uniqueResults;
  } catch (error) {
    console.error("Error filtering Content Reports:", error);
    setLoading(false);
    return []; // Return an empty array in case of error
  } finally {
    setLoading(false);
  }
};


// export const getFilterContentReports = async (
//   reportReasonFilterOptions,
//   reportTypeFilterOptions,
//   reportStatusFilterOptions,
//   // creationDateFilterOptions,
//   creationDateRange,
//   setLoading,
//   handleFilterModalClose
// ) => {
//   // Set loading to true at the beginning of the function
//   setLoading(true);
//   const deduplicate = (arr) => {
//     const uniqueIds = new Set();
//     const uniqueDocs = [];
//     arr.forEach((doc) => {
//       if (!uniqueIds.has(doc.id)) {
//         uniqueIds.add(doc.id);
//         uniqueDocs.push(doc);
//       }
//     });
//     console.log("results:", uniqueDocs);
//     handleFilterModalClose();
//     return uniqueDocs;
//   };

//   try {
//     // Define the reference to your QuickTales collection
//     let queries = [
//       ...reportTypeFilterOptions.map((option) => where("type", "==", option)),
//       ...reportReasonFilterOptions.map((option) =>
//         where("reason", "==", option)
//       ),
//       ...reportStatusFilterOptions.map((option) =>
//         where("status.status", "==", option)
//       ),
//     ];

//     // Add date range filter if provided
//     if (
//       creationDateRange &&
//       creationDateRange.startDate &&
//       creationDateRange.endDate
//     ) {
//       queries.push(where("createdAt", ">=", creationDateRange.startDate));
//       queries.push(where("createdAt", "<=", creationDateRange.endDate));
//     }

//     // Execute the query
//     const q = query(ContentReportsRef, ...queries);
//     const querySnapshot = await getDocs(q);

//     console.log("resultes query:::", querySnapshot.docs[0]);

//     // Convert to map to handle async operations
//     const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
//       const userTemp = await getSingleUser(doc.data().reportedBy);
//       return {
//         id: doc.id,
//         ...doc.data(),
//         reportedByData: userTemp?.data() ? userTemp.data() : {},
//       };
//     });

//     // Wait for all fetches to complete
//     const results = await Promise.all(fetchDetailsPromises);

//     // const uniqueResults = deduplicate(results);
//     return deduplicate(results);
//   } catch (error) {
//     console.error("Error filtering Content Reports:", error);
//     setLoading(false);
//     return []; // Return an empty array in case of error
//   } finally {
//     setLoading(false);
//   }
// };
